import { render, staticRenderFns } from "./QDivisionSelect.vue?vue&type=template&id=53171e2c&"
import script from "./QDivisionSelect.vue?vue&type=script&lang=js&"
export * from "./QDivisionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports